import CovidImg from '../images/covid_dashboard.png';
import JobsDragonsImg from '../images/jobsanddragons.png';
import ClimaImg from '../images/clima_ss.png';
import DayPlannerImg from '../images/dayplanner_ss.png';
import JSQuizImg from '../images/jsquiz_ss.png';
import PwdGenImg from '../images/password_generator_ss.png';


const projects = [
  {
    id: 1,
    name: 'Covid-19 DASHBOARD',
    desc:
      `A Corona virus Dashboard with MAP showing up-to-date statistics 
      of increase of corona virus around the world.Hover over the countries 
      to see additional details for each country in tooltips.`,
    img: CovidImg,
    appLink: 'https://codesandbox.io/s/covid19-dashboard-kmv7r',
    githubLink: 'https://github.com/ianasqazi/covid-dashboard',
    technologiesUsed: `REACT, REACT-ROUTER-DOM, REACTSTRAP, NODE.js, REACTLOADINGG,
    MAPBOX-GL, AXIOS, SWR, COUNTRY-CODE-LOOKUP, COMMA-NUMBER, CORONA Virus Info API's`,
  },
  {
    id: 2,
    name: 'Jobs & Dragons',
    desc:
      `Full stack job search application built in
      a role-playing game (RPG)
      format to make job hunt
      exciting. Each player/job applicant will receive 
      series of quests to complete.A player
      has to successfully complete
      all the levels in order to be eligible to apply jobs. `,
    img: JobsDragonsImg,
    appLink: 'https://jobs-and-dragons.herokuapp.com/',
    githubLink: 'https://github.com/Winyumi/jobs-and-dragons',
    technologiesUsed: `REACT, REACT-HOOKS, REACT-ROUTER, CONTEXT-API, EXPRESS.js,
    NODE.js, MATERIALIZE CSS, MONGO DB, MONGOOSE, AUTH0, GITHUB API and ADZUNA API`,
  },
  {
    id: 3,
    name: 'CLIMA - WEATHER',
    desc:
      `Built an application to access current weather forcast of over 200,000 cities using
      vanilla JavaScript and jQuery.`,
    img: ClimaImg,
    appLink: 'https://ianasqazi.github.io/Weather-App/',
    githubLink: 'https://github.com/ianasqazi/Weather-App',
    technologiesUsed: `JAVASCRIPT, jQUERY, HTML, CSS, AJAX and OPEN WEATHER API`,
  },
  {
    id: 12,
    name: 'Day Planner',
    desc:
      `Simple Calendar Application that allows the user to save events for each hour of the
      day which is saved in browser's Local Storage.`,
    img: DayPlannerImg,
    appLink: 'https://ianasqazi.github.io/Day-Planner/',
    githubLink: 'https://github.com/ianasqazi/Day-Planner',
    technologiesUsed: `JAVASCRIPT, jQUERY, BOOTSTRAP and MOMENT.js`,
  },
  {
    id: 13,
    name: 'JS CODE QUIZ',
    desc:
      `A simple questionnaire application which will give you score based on how fast you
      answer the questions.`,
    img: JSQuizImg,
    appLink: 'https://ianasqazi.github.io/JS-Quiz/',
    githubLink: 'https://github.com/ianasqazi/JS-Quiz/',
    technologiesUsed: `NODE.js, INQUIRER, OPEN, JEST`,
  },
  {
    id: 14,
    name: 'Random Password Generator',
    desc:
      `Generate a random password of variable length and complexity by providing input by user.`,
    img: PwdGenImg,
    appLink: 'https://ianasqazi.github.io/Password-Generator/',
    githubLink: 'https://github.com/ianasqazi/Password-Generator',
    technologiesUsed: `JAVASCRIPT, HTML, CSS and BOOTSTRAP`,
  },
];

export default projects;
